import * as Stimulus from "@hotwired/stimulus"

window.Stimulus = Stimulus
window.stimulusApp = Stimulus.Application.start()

stimulusApp.register(
  "autofocus-end",
  class extends Stimulus.Controller {
    connect() {
      if (this.element.hasAttribute("autofocus")) {
        this.moveCursorToEnd()
      }
    }

    moveCursorToEnd() {
      // setSelectionRange does not work on email input type, so using this trick instead.
      // Also, using setTimeout to ensure this runs after the input has been fully initialized
      setTimeout(() => {
        const value = this.element.value
        this.element.value = ""
        this.element.value = value
      }, 0)
    }
  },
)

// Trigger a click on an element when the page loads
// and the URL hash matches the element's data-autoclick-navhash-value attribute.
stimulusApp.register(
  "autoclick",
  class extends Stimulus.Controller {
    static values = {
      navhash: String,
    }

    connect() {
      const initialHash = location.hash
      window.HB.onReady(() => {
        if (location.hash === initialHash) {
          this.#handleHash(initialHash)
        }
      })
    }

    #handleHash = (initialHash) => {
      if (this.hasNavhashValue && initialHash == `#${this.navhashValue}`) {
        this.element.click()
      }
    }
  },
)

/* Controller for more control over buttons. */
stimulusApp.register(
  "button",
  class extends Stimulus.Controller {
    loading() {
      this.element.classList.add("btn_loading", "btn_disabled")
      this.element.disabled = true
    }
  },
)

/* When attached to a turbo frame it modifies it's loading so that the content
  is loaded in its place instead of inside the tag. I.e. the content effectively
  replaces the frame and the frame disappears.
  Before: `<turbo-frame data-controller="disappearing-frame" src="/content"></turbo-frame>`
  Between (not rendered): `<turbo-frame data-controller="disappearing-frame" src="/content"><div>Loaded content from /content</div></turbo-frame>`
  After: `<div>Loaded content from /content</div>` */
stimulusApp.register(
  "disappearing-frame",
  class extends Stimulus.Controller {
    connect() {
      this.element.addEventListener("turbo:before-frame-render", (event) => {
        event.detail.render = (currentElement, newElement) => {
          requestAnimationFrame(() => {
            const parent = currentElement.parentNode
            while (newElement.firstChild) {
              parent.insertBefore(newElement.firstChild, currentElement)
            }
            currentElement.remove()
          })
        }
      })
    }
  },
)

/* Used for the "Something went wrong" error inside a turbo frame.
   Allows retrying loading the frame. */
stimulusApp.register(
  "smth-went-wrong",
  class extends Stimulus.Controller {
    static classes = ["btnLoading"]

    retry(e) {
      e.target.disabled = true
      e.target.classList.add(...this.btnLoadingClasses)
      this.element.closest("turbo-frame").reload()
    }
  },
)
